import type { QueryClient } from "@tanstack/react-query";

import { useOfflineModeState } from "@src/states/offline_mode";
import { usePlayerState } from "@src/states/player";

import { player } from "@src/services/player";
import { DEFAULT_TRACK_ID } from "@src/services/player/constants";

import { enterOfflineMode } from "@src/utils/offline/enterOfflineMode";
import { safePlayOnline } from "@src/utils/online/safePlayOnline";
import { setupOnlineMode } from "@src/utils/online/setupOnlineMode";

export function exitOfflineMode(
  playingOrPaused: "playing" | "paused" | null,
  queryClient: QueryClient,
) {
  useOfflineModeState.setState({
    offlineSongsPlayed: -1,
    insertingOfflineSpot: false,
  });

  console.warn(`Exiting offline mode (${playingOrPaused})`);
  player.removeTrack("offline").then(() => {
    // currentTrack ainda mostra o metadado offline ("Modo Offline / arquivo").
    // Enquanto offline, o usePlayer mantém nextTrack = música atual da rádio;
    // promovê-lo evita exibir o metadado offline até o próximo refetch da query.
    const { nextTrack } = usePlayerState.getState();
    usePlayerState.setState({
      currentTrackId: DEFAULT_TRACK_ID,
      ...(nextTrack ? { currentTrack: nextTrack } : {}),
    });

    setupOnlineMode(queryClient);
    if (playingOrPaused === "playing") {
      safePlayOnline(queryClient, () => enterOfflineMode(queryClient, "safePlayOnline"));
    }
  });
}
